<template>
  <v-select
    outlined
    required
    dense
    hide-details
    item-value="value"
    prepend-inner-icon="mdi-calendar-month-outline"
    :menu-props="{ bottom: true, offsetY: true }"
    :value="initialMonth"
    :items="months"
    :label="$t('routines_reminder.month')"
    :placeholder="$t('routines_reminder.month')"
    @change="$emit('change', $event)"
  >
  </v-select>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MonthSelector',
  props: {
    initialMonth: {
      type: String,
    },
  },
  data() {
    return {
      months: [],
    }
  },

  mounted() {
    this.createMonthsList()
  },

  methods: {
    createMonthsList() {
      const endMonth = moment().endOf('year')
      const interval = 1

      const monthsList = []
      let currentMonth = moment().startOf('year')

      while (currentMonth.isSameOrBefore(endMonth, 'month')) {
        monthsList.push({
          value: currentMonth.format('M'),
          text: currentMonth.format('MMMM'),
        })

        currentMonth.add(interval, 'months')
      }

      this.months = monthsList
    },
  },
}
</script>
